const buttonFormActions = {
  cancel: 'Cancelar acción',
  reopen: 'Reabrir acción',
  done: 'Concluir acción'
};

export default buttonFormActions;
